import React from 'react';
import SideBar from 'components/newSideBar';
import WorkZoneNavigation from './Navigation';

const WorkZoneSideBar = () => {
  return <SideBar navigation={WorkZoneNavigation} fromWZ={true}/>;
};

export default WorkZoneSideBar;
